export default {"src":"/_next/static/media/white-furniture.26ebcb15.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};